import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { get } from 'global/lib/lodash';
import useStyles from './styles';
import { setView } from 'redux/actions/view';
import { Row } from '../row';
import { Text } from '../text';
import Switch from '../switch';
import { useEdit } from '../../hooks/useEdit';
import { userHasPermissions } from 'redux/actions/userLogin';

export const SelectLangEditBar = (props) => {
  const showTranslations = get(props, 'showTranslations', false);
  const hasPerm = userHasPermissions(['createLibrary']);
  const canEdit = get(props, 'canEdit', hasPerm);

  const { editOn, toggleEdit } = useEdit();

  const lang = useSelector((state) => get(state, 'view.lang'));
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleChange = (e, val) => {
    if (val) {
      dispatch(setView({ lang: { ...lang, id: val } }));
    }
  };

  const show = showTranslations || canEdit;

  if (!show) {
    return null;
  }

  return (
    <div className={classes.container}>
      {showTranslations && (
        <Row className={classes.rowItem}>
          <Text type={'label_medium'}>Available In</Text>
          <ToggleButtonGroup exclusive className={classes.btnGroup} size="small" value={get(lang, 'id')} onChange={handleChange}>
            {get(lang, 'avail', []).map((a) => (
              <ToggleButton key={a.id} value={a.id}>
                {a.title}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Row>
      )}

      {canEdit && (
        <Row className={classes.rowItem}>
          <Text type={'label_medium'}>Edit Tools</Text>
          <Switch checked={editOn} onChange={toggleEdit} />
        </Row>
      )}
    </div>
  );
};
